/* eslint-disable no-param-reassign */
import produce from 'immer';
var fastqMatcherUpdated = produce(function (draft, action) {
  var _action$payload = action.payload,
    secondaryAnalysisId = _action$payload.secondaryAnalysisId,
    sublibraryUserSelections = _action$payload.sublibraryUserSelections;
  draft[secondaryAnalysisId].files.sublibraryUserSelections = sublibraryUserSelections;
});
export default fastqMatcherUpdated;